export enum UserLanguage {
  en = 'en',
  he = 'he',
}
